import { render, staticRenderFns } from "./footer-subscription.vue?vue&type=template&id=a5982790&scoped=true"
import script from "./footer-subscription.vue?vue&type=script&lang=js"
export * from "./footer-subscription.vue?vue&type=script&lang=js"
import style0 from "./footer-subscription.vue?vue&type=style&index=0&id=a5982790&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5982790",
  null
  
)

export default component.exports